/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Damper_ReturnInputs */



/**
* | output |
* | --- |
* | "Return air damper" |
*
* @param {Air_Handler_Unit_Damper_ReturnInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_damper_return = /** @type {((inputs?: Air_Handler_Unit_Damper_ReturnInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Damper_ReturnInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air damper")
	return /** @type {LocalizedString} */ ("Volet d'air reprise")
});